module.exports = __webpack_public_path__ + "img/default-double-circle.ac6ee5c7.svg";